import { useEffect } from "react";

const HOME_TITLE = "诱人的飞行 - 最新影视内容与剧情介绍";

export default function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title;
    return () => {
      document.title = HOME_TITLE;
    };
  }, [title]);
}